import { render, staticRenderFns } from "./Subproduto.vue?vue&type=template&id=c7d35b8e"
import script from "./Subproduto.vue?vue&type=script&lang=js"
export * from "./Subproduto.vue?vue&type=script&lang=js"
import style0 from "./Subproduto.vue?vue&type=style&index=0&id=c7d35b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports